import { useContext, useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import queryString from 'qs'
import { loadStripe } from '@stripe/stripe-js'
import StripePayment from '../components/StripePayment'
import { ProspectContext } from './../contexts/ProspectContext'
import backImage from './../img/go_back.svg'

// Load Stripe outside component to avoid recreating Stripe object on every render
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY)

const Subscribe = () => {
  const { state } = useContext(ProspectContext)
  const [processingBancontactPayment, setProcessingBancontactPayment] = useState({
    status: false,
    source: null
  })
  const location = useLocation()
  const history = useHistory()

  // Check if bancontact payment is processing (=handle bancontact redirection)
  useEffect(() => {
    if (location.search) {
      const query = queryString.parse(location.search) || {}
      const paymentIntent = query.payment_intent || query['?payment_intent']

      if (paymentIntent) {
        setProcessingBancontactPayment({ status: true, source: paymentIntent })
        // Clean up URL to prevent re-processing on re-renders
        history.replace(`/prospect/${state.prospect.prospectId}/${state.selectedPlan.title}/subscribe`)
      }
    }
  }, [location.search, state.prospect.prospectId, state.selectedPlan.title, history])

  return (
    <div className='Subscribe'>
      <Helmet>
        <title>BA beroep mandaten Ond. Rb.</title>
      </Helmet>
      <Container>
        <section>
          <h1>
            <a href={`/ui/prospect/${state.prospect.prospectId}`} style={{ marginRight: '1rem' }}><img src={backImage} alt='Ga Terug' /></a>
            Onderschrijven Formule {state.selectedPlan.title} <span className='highlighted small'>voor {state.selectedPlan.price}&euro;</span>
          </h1>
          <p className='h4 mt-5 mb-4'>Uw details :</p>
          <Row>
            <Col className='mb-3 mb-lg-0' md={6} lg={3}>
              <p className='h5'>Rechtbank en afdeling / Hof :</p>
              <p>{state.prospect.model.courtAndDepartment}</p>
            </Col>
            <Col className='mb-3 mb-lg-0' md={6} lg={3}>
              <p className='h5'>Mandaatnummer :</p>
              <p>{state.prospect.model.bankruptcyNumber}</p>
            </Col>
          </Row>
        </section>
        <section className='mt-3 mt-lg-5'>
          <Row>
            <Col md={12} lg={{ span: 8 }}>
              <p className='h4 mb-3'>Betaling :</p>
              <StripePayment stripePromise={stripePromise} processingBancontactPayment={processingBancontactPayment} />
            </Col>
          </Row>
        </section>
      </Container>
    </div>
  )
}

export default Subscribe
